module.exports = __webpack_public_path__ + "images/corners/Diamond.a89ab00e77fa295e6a568de71dd0f6a1.jpg";